import { RouteConfig } from 'vue-router'

const List = () => import('../views/run-task/List.vue')

const Form = () => import('../views/run-task/Form.vue')

const TaskStat = () => import('../views/run-task/TaskStat.vue')
const PeriodStat = () => import('../views/run-task/PeriodStat.vue')
const ClazzStat = () => import('../views/run-task/ClazzStat.vue')
const StudentRecord = () => import('../views/run-task/StatStudentRecord.vue')
const Report = () => import('../views/run-task/Report.vue')

const PunchForm = () => import('../views/run-task/PunchForm.vue')
const PunchFormStep1 = () => import('../views/run-task/PunchFormStep1.vue')
const PunchFormStep2 = () => import('../views/run-task/PunchFormStep2.vue')
const BodyForm = () => import('../views/run-task/BodyUpForm.vue')
const BodyFormStep1 = () => import('../views/run-task/BodyFormStep1.vue')
const BodyFormStep2 = () => import('../views/run-task/BodyFormStep2.vue')
const BodyStat = () => import('../views/run-task/BodyStat.vue')
const PunchStat = () => import('../views/run-task/PunchStat.vue')
const PunchClazzStat = () => import('../views/run-task/PunchClazzStat.vue')
const PunchStudentStat = () => import('../views/run-task/PunchStudentStat.vue')

const StandardStat = () => import('../views/run-task/StandardStat.vue')
const StandardClazzStat = () => import('../views/run-task/StandardClazzStat.vue')
const StandardStudentStat = () => import('../views/run-task/StandardStudentStat.vue')
const StandardStudentRecord = () => import('../views/run-task/StandardStudentRecord.vue')

const DrillSelector = () => import('../views/run-task/DrillSelector.vue')

export const listRoute: RouteConfig = {
  path: '/run-task-list',
  name: 'run_task_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '运动任务',
  },
}

export const jumpropeTaskRoute: RouteConfig = {
  path: '/run-task-list?universityTargetType=jumprope', // 用到了运动任务，但这种模式进入直接进入选中跳绳状态
  name: 'run_task_list_university_jumprope',
  component: List,
  props: (route) => ({ ...route.query, ...route.params, universityTargetType: 'jumprope' }),
  meta: {
    title: '跳绳任务',
  },
}

export const freestyleTaskRoute: RouteConfig = {
  path: '/run-task-list?universityTargetType=freestyle',
  name: 'run_task_list_university_freestyle',
  component: List,
  props: (route) => ({ ...route.query, ...route.params, universityTargetType: 'freestyle' }),
  meta: {
    title: '综合任务',
  },
}

export const formRoute: RouteConfig = {
  path: '/run-task-form',
  name: 'run_task_form',
  component: Form,
  props: (route) => ({ ...route.query, ...route.params }),
  children: [
    {
      path: 'step1',
      name: 'run_task_form_step1',
      component: () => import('../views/run-task/FormStep1.vue'),
      meta: {
        title: '布置任务（1/2）',
      },
    },
    {
      path: 'step2',
      name: 'run_task_form_step2',
      component: () => import('../views/run-task/FormStep2.vue'),
      meta: {
        title: '布置任务（2/2）',
      },
    },
  ],
}

export const punchFormRoute: RouteConfig = {
  path: '/run-task-punch-form',
  name: 'run_task_punch_form',
  component: PunchForm,
  props: (route) => ({ ...route.query, ...route.params }),
  children: [
    {
      path: 'step1',
      name: 'run_task_punch_form_step1',
      component: PunchFormStep1,
      meta: {
        title: '布置任务（1/2）',
      },
    },
    {
      path: 'step2',
      name: 'run_task_punch_form_step2',
      component: PunchFormStep2,
      meta: {
        title: '布置任务（2/2）',
      },
    },
  ],
}

export const bodyFormRoute: RouteConfig = {
  path: '/run-task-body-form',
  name: 'run_task_body_form',
  component: BodyForm,
  props: (route) => ({ ...route.query, ...route.params }),
  children: [
    {
      path: 'step1',
      name: 'run_task_body_form_step1',
      component: BodyFormStep1,
      meta: {
        title: '布置任务（1/2）',
      },
    },
    {
      path: 'step2',
      name: 'run_task_body_form_step2',
      component: BodyFormStep2,
      meta: {
        title: '布置任务（2/2）',
      },
    },
  ],
}

export const taskStatRoute: RouteConfig = {
  path: '/run-task-task-stat',
  name: 'run_task_task_stat',
  component: TaskStat,
  props: (route) => ({ ...route.query, ...route.params, showPoster: route.query.showPoster === '1' }),
  meta: {
    title: '任务详情',
  },
}

export const taskPunchStatRoute: RouteConfig = {
  path: '/run-task-punch-stat',
  name: 'run_task_punch_stat',
  component: PunchStat,
  props: (route) => ({ ...route.query, ...route.params, showPoster: route.query.showPoster === '1' }),
  meta: {
    title: '任务详情',
  },
}

export const taskBodyStatRoute: RouteConfig = {
  path: '/run-task-body-stat',
  name: 'run_task_body_stat',
  component: BodyStat,
  props: (route) => ({ ...route.query, ...route.params, showPoster: route.query.showPoster === '1' }),
  meta: {
    title: '任务详情',
  },
}

export const periodStatRoute: RouteConfig = {
  path: '/run-task-period-stat',
  name: 'run_task_period_stat',
  component: PeriodStat,
  props: (route) => ({ ...route.query, ...route.params, hasStart: JSON.parse(route.query.hasStart as string) }),
  meta: {
    title: '任务详情',
  },
}

export const clazzStatRoute: RouteConfig = {
  path: '/run-task-clazz-stat',
  name: 'run_task_clazz_stat',
  component: ClazzStat,
  props: (route) => ({ ...route.query, ...route.params, clazzID: JSON.parse(route.query.clazzID as string) }),
  meta: {
    title: '任务详情',
  },
}

export const studentRecordRoute: RouteConfig = {
  path: '/run-task-student-record',
  name: 'run_task_student_record',
  component: StudentRecord,
  props: (route) => ({ ...route.query, ...route.params, clazzID: JSON.parse(route.query.clazzID as string) }),
  meta: {
    title: '个人训练记录',
  },
}

export const studentReportRoute: RouteConfig = {
  path: '/run-task-student-report',
  name: 'run_task_student_report',
  component: Report,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '训练报告',
  },
}

export const punchClazzStatRoute: RouteConfig = {
  path: '/run-task-punch-clazz-stat',
  name: 'run_task_punch_clazz_stat',
  component: PunchClazzStat,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '任务详情',
  },
}

export const punchStudentStatRoute: RouteConfig = {
  path: '/run-task-punch-student-stat',
  name: 'run_task_punch_student_stat',
  component: PunchStudentStat,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '任务详情',
  },
}

export const taskStandardStatRoute: RouteConfig = {
  path: '/run-task-standard-stat',
  name: 'run_task_standard_stat',
  component: StandardStat,
  props: (route) => ({ ...route.query, ...route.params, showPoster: route.query.showPoster === '1' }),
  meta: {
    title: '任务详情',
  },
}

export const taskStandardClazzStatRoute: RouteConfig = {
  path: '/run-task-standard-clazz-stat',
  name: 'run_task_standard_clazz_stat',
  component: StandardClazzStat,
  props: (route) => ({ ...route.query, ...route.params, showPoster: route.query.showPoster === '1' }),
  meta: {
    title: '任务详情',
  },
}

export const taskStandardStudentStatRoute: RouteConfig = {
  path: '/run-task-standard-student-stat',
  name: 'run_task_standard_student_stat',
  component: StandardStudentStat,
  props: (route) => ({ ...route.query, ...route.params, showPoster: route.query.showPoster === '1' }),
  meta: {
    title: '个人达标记录',
  },
}

export const taskStandardStudentRecordRoute: RouteConfig = {
  path: '/run-task-standard-student-record',
  name: 'run_task_standard_student_record',
  component: StandardStudentRecord,
  props: (route) => ({ ...route.query, ...route.params, showPoster: route.query.showPoster === '1' }),
  meta: {
    title: '个人训练记录',
  },
}

export const drillRoute: RouteConfig = {
  path: '/run-task-drill',
  name: 'run_task_drill',
  component: DrillSelector,
  meta: {
    title: '综合任务',
    ignoreLogin: true,
  },
}

export default [
  listRoute,
  jumpropeTaskRoute,
  freestyleTaskRoute,
  formRoute,
  punchFormRoute,
  bodyFormRoute,
  taskStatRoute,
  periodStatRoute,
  clazzStatRoute,
  studentRecordRoute,
  studentReportRoute,
  taskPunchStatRoute,
  taskBodyStatRoute,
  punchClazzStatRoute,
  punchStudentStatRoute,
  taskStandardStatRoute,
  taskStandardClazzStatRoute,
  taskStandardStudentStatRoute,
  taskStandardStudentRecordRoute,
  drillRoute,
]
